import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import getPropertyValue from '../../../dataAccessHelpers/getPropertyValue';
import I18n from 'I18n';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { usageTracker } from '../../../utils/usageTracker';
import useDeletePayment from '../../../hooks/useDeletePayment';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DeleteModal = ({
  objectId,
  onClose,
  properties,
  associations,
  isSyncedPayment
}) => {
  const amount = I18n.formatIntlCurrency(Number(getPropertyValue(properties, 'hs_initial_amount')), {
    currencyCode: getPropertyValue(properties, 'hs_currency_code')
  });
  const {
    definition,
    value
  } = properties.hs_processor_type;
  const processorTypeDisplayValue = getDisplayedValue(definition, value);
  const {
    deletePaymentMutation,
    deletePaymentButtonLoading
  } = useDeletePayment({
    associations,
    onClose
  });
  const handleDeleteConfirm = () => {
    usageTracker.track('paymentCRMSidebarUsage', {
      action: 'deleteModalSubmitClicked'
    });
    deletePaymentMutation({
      variables: {
        objectId
      }
    }).catch(() => {});
  };
  const handleDeleteCancel = () => {
    usageTracker.track('paymentCRMSidebarInteraction', {
      action: 'deleteModalCancelClicked'
    });
    onClose();
  };
  return /*#__PURE__*/_jsxs(Modal, {
    use: "danger",
    "data-test-id": "delete-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.modal.header"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleDeleteCancel,
        disabled: deletePaymentButtonLoading
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: isSyncedPayment ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.modal.syncedPayment.body",
            options: {
              externalSource: processorTypeDisplayValue
            }
          })
        }), /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.modal.syncedPayment.warning"
            })
          })
        })]
      }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.modal.body",
        options: {
          amount
        }
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        use: "danger",
        onClick: () => handleDeleteConfirm(),
        loading: deletePaymentButtonLoading,
        "data-test-id": "delete-payment-confirm-btn",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.modal.delete"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        disabled: deletePaymentButtonLoading,
        onClick: handleDeleteCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.modal.cancelButtonText"
        })
      })]
    })]
  });
};
export default DeleteModal;